
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/common/Navbar';
import Home from './pages/Home';
import OpenRoute from './components/core/Auth/OpenRoute';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Contact from './pages/Contact';
import About from './pages/About';
import ForgotPassword from './pages/ForgotPassword';
import VerifyEmail from './pages/VerifyEmail';
import UpdatePassword from './pages/UpdatePassword';
import PrivateRoute from './components/core/Auth/PrivateRoute';
import Dashboard from './pages/Dashboard';
import MyProfile from './components/core/Dashboard/MyProfile';
import Settings from './components/core/Dashboard/Settings';
import { useSelector } from 'react-redux';
import { ACCOUNT_TYPE } from './utils/constants';
import Cart from './components/core/Dashboard/Cart';
import EnrolledCourses from './components/core/Dashboard/EnrolledCourses';
import Error from './pages/Error';
import AddCourse from './components/core/Dashboard/AddCourse';
import EditCourse from './components/core/Dashboard/EditCourse';
import MyCourses from './components/core/Dashboard/MyCourses';
import Instructor from './components/core/Dashboard/InstructorDashboard/Instructor';
import Catalog from './pages/Catalog';
import CourseDetails from './pages/CourseDetails';
import ViewCourse from './pages/ViewCourse';
import VideoDetails from './components/core/ViewCourse/VideoDetails';

function App() {
  
  const {user} = useSelector((state)=> state.profile);

  return (
<div className="w-screen min-h-screen bg-richblack-900 flex flex-col font-inter overflow-y-hidden">
<Navbar/>
<Routes>
  <Route path='/' element={<Home/>}/>
  {/* //catalog data */}
  <Route path='catalog/:catalogName' element={<Catalog/>}/>
  <Route path='/courses/:courseId' element={<CourseDetails/>}/>

  <Route
  path='signup'
  element={
    <OpenRoute>
    <Signup/>
    </OpenRoute>
  }
  />

  <Route
  path='login'
  element={
    <OpenRoute>
      <Login/>
    </OpenRoute>
  }
  />

  <Route 
  path='forgot-password'
  element={
    <OpenRoute>
      <ForgotPassword/>
    </OpenRoute>
  }
  />

  <Route
  path='verify-email'
  element={
    <OpenRoute>
      <VerifyEmail/>
    </OpenRoute>
  }
  />

  <Route
  path='update-password/:id'
  element={
    <OpenRoute>
      <UpdatePassword/>
    </OpenRoute>
  }
  />

  <Route path='/about' element={<About/>}/>
  <Route path='/contact' element={<Contact/>}/>

{/* //Dashboard ke andr ke sare router */}
  <Route element={
    <PrivateRoute>
      <Dashboard/>
    </PrivateRoute>
  }>
 
  <Route path='dashboard/my-profile' element={<MyProfile/>}/>
  <Route path='dashboard/Settings' element={<Settings/>}/>

{/* Jo only Student Accesses kr skte bo  */}
  {
    user?.accountType === ACCOUNT_TYPE.STUDENT && (
      <>
      <Route path='dashboard/cart' element={<Cart/>}/>
    <Route path="dashboard/enrolled-courses" element={<EnrolledCourses/>}/>
      </>
    )
  }

{
  user?.accountType === ACCOUNT_TYPE.INSTRUCTOR &&(
    <>
    <Route path='dashboard/instructor' element={<Instructor/>}/>
    <Route path="dashboard/add-course" element={<AddCourse/>} />
    <Route path="dashboard/my-courses" element={<MyCourses/>}/>
    <Route path="dashboard/edit-course/:courseId" element={<EditCourse/>}/>
    </>
  )
}
  </Route>
  <Route element={
    <PrivateRoute>
     <ViewCourse/> 
    </PrivateRoute>
  }>
    {
      user?.accountType === ACCOUNT_TYPE.STUDENT &&(
        <>
        <Route 
         path="view-course/:courseId/section/:sectionId/sub-section/:subSectionId"
         element={<VideoDetails/>}
        />
        </>
      )
    }
    
  </Route>

  <Route path='*' element={<Error/>}/>

</Routes>
   </div>
  );
}

export default App;
